import { commonFilter } from './filter';

export default {
  pageName: 'topic',
  pageId: '20015',
  pagePath: '/opinion/Stats/Topic',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    STO_sentiment: {
      buttonId: '2001501',
    },
    ...commonFilter,
  },
};
